export const intlEnUs = {
    测试: 'test',
    登录: 'Login',
    注册: 'Register',
    变量的例子: 'example of variable {value}',
    多样式多语言例子: '<span style="font-size: 12px;color: #d7cab3;">example of variable <span style="font-size: 16px;color: #fff;font-weight: 600;">@money</span></span>',
    体育: 'sports',
    存款: 'Deposit',
    提款: 'Withdraw',
    请登录: 'please login',
    余额刷新成功: 'balance refresh success',
    我的金额: 'My amount',
    我的邀请码: 'My invitation code',
    复制成功: 'copy success',
    下一次抽奖: 'Next Draw',
    您没有抽奖的机会: 'you have no chance to draw',
    规则: 'Rules',
    我的: 'ACCOUNT',
    我的信息: 'My Info',
    资金详情: 'Balance details',
    在线客服: 'Help Center',
    客服暂未配置: 'customer service not configured',
    促销码: 'Promo Code',
    请输入促销码: 'please enter the promotion code',
    验证码: 'verification code',
    请输入验证码: 'please enter the verification code',
    提交: 'Submit',
    退出登录: 'logout',
    提示: 'hint',
    '确定要退出登录吗？': 'Are you sure you want to log out?',
    取消: 'Cancel',
    确定: 'Confirm',
    '升级到 {value} 还需要 {value}': 'Upgrade to {value1} with {value2} left',
    头像: 'Avatar',
    用户名: 'username',
    登录密码: 'Login password',
    提现密码: 'Withdrawal password',
    修改提现密码: 'change withdrawal password',
    修改密码: 'change password',
    设置提现密码: 'set withdrawal password',
    请输入提现密码: 'please enter the withdrawal password',
    请再次输入提现密码: 'please enter the withdrawal password again',
    提现密码不能为空: 'withdrawal password cannot be empty',
    确认提现密码不能为空: 'confirmation of withdrawal password cannot be empty',
    提现密码格式不正确: 'incorrect withdrawal password format',
    确认提现密码格式不正确: 'incorrect confirmation of withdrawal password format',
    提现密码和确认提现密码不一致: 'withdrawal password and confirmation of withdrawal password do not match',
    设置提现密码成功: 'set withdrawal password successfully',
    请输入旧密码: 'please enter the old password',
    请输入新密码: 'please enter a new password',
    请再次输入新密码: 'please enter the new password again',
    旧密码不能为空: 'old password cannot be empty',
    新密码不能为空: 'new password cannot be empty',
    确认密码不能为空: 'confirmation password cannot be empty',
    '旧密码格式不正确, 请输入6-18位字母或数字': 'incorrect old password format, please enter 6-18 characters of letters or numbers',
    '新密码格式不正确, 请输入6-18位字母或数字': 'incorrect new password format, please enter 6-18 characters of letters or numbers',
    '确认密码格式不正确, 请输入6-18位字母或数字': 'incorrect confirmation password format, please enter 6-18 characters of letters or numbers',
    新密码和确认密码不一致: 'new password and confirmation password do not match',
    '修改密码成功, 请重新登录': 'password changed successfully, please log in again',
    修改提现密码成功: 'withdrawal password changed successfully',
    选择头像: 'select avatar',
    今天: 'today',
    昨天: 'yesterday',
    一个月内: 'within a month',
    余额: 'Balance',
    编号: 'number',
    备注: 'note',
    提现金额: 'withdrawal amount',
    充值: 'Deposit',
    账变: 'Account Change',
    所有类型: 'all types',
    每天: 'every day',
    每周: 'every week',
    每月: 'every month',
    活动名称: 'activity name',
    优惠金额: 'preferential amount',
    申请时间: 'application time',
    '发放/审核时间': 'distribution/audit time',
    状态: 'status',
    活动奖项: 'activity award',
    排名: 'ranking',
    每日列表: 'daily list',
    每周列表: 'weekly list',
    每月列表: 'monthly list',
    没有排名: 'no rank',
    我的投注: 'my bet',
    我的奖励: 'My Rewards',
    剩余排名: 'remaining rank',
    空缺: 'vacant',
    奖励: 'reward',
    总投注: 'total bet',
    投注: 'Bet',
    '占所有玩家总投注额的 {value} %': 'take {value} % of the total bet of all players',
    暂无数据: 'no data',
    首页: 'HOME',
    优惠活动: 'PROMO',
    推广: 'EARN',
    请选择: 'please choose',
    年: 'year',
    月: 'month',
    日: 'day',
    上午: 'morning',
    下午: 'afternoon',
    天: 'day',
    周: 'week',
    投注返利详情:
        "<span style='font-size: 10px;color: #d7cab3;'>Your team's total bet amount is {value1}, and you can get up to <span style='font-size: 14px;color: #fff;font-weight: 500;'>{value2}</span> per monthly</span>",
    优惠活动详情: 'Promotion details',
    活动申请: 'Activity application',
    加载中: 'Loading',
    申请: 'Apply',
    申请成功: 'Application successful',
    申请失败: 'Application failed',
    所有记录: 'All records',
    申请中: 'Applying',
    发放成功: 'Issuance successful',
    审核失败: 'Review failed',
    活动申请记录: 'Activity application records',
    原因: 'Reason',
    邮件: 'Mail',
    邮件最多可保存30天: 'Mails can be saved for up 30 days',
    删除已读: 'Delete Read',
    全部接收: 'Receive all',
    邮件详情: 'Mail details',
    删除: 'Delete',
    确认密码: 'Confirm password',
    真实姓名: 'Real name',
    姓: 'Surname',
    名: 'First name',
    邮箱: 'Email',
    邮箱验证码: 'Email verification code',
    发送: 'Send',
    手机号: 'Mobile number',
    手机验证码: 'Mobile verification code',
    出生日期: 'Date of birth',
    twitter: 'twitter',
    facebook: 'facebook',
    证件类型: 'ID type',
    证件号: 'ID number',
    推广码: 'Promotion code',
    优惠码: 'redemption code',
    登录成功: 'Login successful',
    登录失败: 'Login failed',
    登录账号: 'Login account',
    请输入正确的邮箱: 'Please enter a valid email address',
    请选择手机区号: 'Please select a mobile area code',
    手机号校验: 'Please enter a 6-12 digit mobile number',
    请输入10位手机号: 'Please enter a 10 digit mobile number',
    验证码发送成功: 'Verification code sent successfully',
    用户名验证: 'Username must start with (6-15) letters and a combination of lowercase letters and numbers',
    用户名不能以test为起始: 'Username cannot start with test',
    密码必须为6位数字: 'Password must be 6 digits',
    确认密码必须为6位数字: 'Confirm password must be 6 digits',
    两次输入的密码不一致: 'Enter twice The password does not match.',
    登录密码验证: 'The password must be a combination of (6 to 18 characters) of letters, numbers or special characters',
    确认登录密码验证: 'Confirm that the password must be a combination of (6 to 18 characters) of letters, numbers or special characters',
    请输入正确的姓名: 'Please enter your correct name',
    请输入出生日期: 'Please enter your date of birth',
    请输入您的twitter账号: 'Please enter your {value} account',
    请输入您的facebook账号: 'Please enter your Facebook account',
    推广码校验: 'Confirm that you have entered the correct promotional code (1 to 8 digits)',
    推广码校验2: 'Please enter the promotional code',
    请点击开始验证: 'Please click Start Verification',
    请输入邮箱验证码: 'Please enter the email verification code',
    请输入手机验证码: 'Please enter the mobile verification code',
    请输入姓: 'Please enter your last name',
    请输入名: 'Please enter your first name',
    请输入证件号: 'Please enter your ID number',
    请输入有效的CURP: 'Please enter a valid CURP',
    '请输入11~14位数字': 'Please enter 11 to 14 digits',
    请选择证件类型: 'Please select the ID type',
    请接受服务条款: 'Please accept the terms of service',
    邀请奖励: 'Invite Rewards',
    问题1: 'Q1: What does commission split mean?',
    回答1: 'A1: After inviting friends to join the application and bind your invitation code, you will receive additional commission based on the consumption of these friends at a certain ratio.',
    问题2: 'Q2: What does club mean?',
    回答2: 'A2: Your club consists of all your agent team members.',
    问题3: 'Q3: How can I upgrade to a higher club star rating?',
    回答3: 'A3: You can upgrade by inviting more friends or collectively consuming with team members. For more detailed information, please refer to the upgrade requirements table.',
    问题4: 'Q4: How do I receive rewards?',
    回答4: "A4: Once your friends or your friends' invitations make purchases, you will immediately receive all rewards, which will be deposited into your commission account and can be withdrawn to your wallet the next day.",
    问题5: 'Q5: Are there any wagering requirements for withdrawing rewards?',
    回答5: 'A5: There is a one-time wagering requirement.',
    问题6: 'Q6: When can I use my rewards?',
    回答6: 'A6: You can withdraw your rewards to your wallet for spending the next day. Sometimes there may be slight delays. Thank you for your understanding.',
    佣金比例详情:
        '※You can earn a percentage of your bets on A, B, and C. Please refer to the image below for specific commission rates.',
    返利比例详情: "※Different games have different rebate ratios. You can also increase the rebate ratio by upgrading your club's star rating.",
    立即邀请: 'Invite Now!',
    佣金率: 'Commission rate',
    流水返利: 'Rebate on turnover',
    俱乐部之星: 'Club Stars',
    佣金等级: 'Lv{value} commission',
    首存返利: 'First Deposit Rebate',
    什么是俱乐部: 'What is a club?',
    俱乐部的星级越高介绍: "You and all your agents form your club. The higher the club's star rating, the higher the rebate ratio.",
    你的俱乐部: 'Your Club',
    如何提高俱乐部的星级: "How to increase the club's star rating?",
    代理要求: 'Agent Requirements',
    投注要求: 'Betting Requirements',
    无星: 'None Star',
    一星: 'One Star',
    二星: 'Two Star',
    三星: 'Three Star',
    全部: 'All',
    我的奖金: 'My bonus',
    下一级: 'Next level',
    累计存款: 'Accummulate Deposit {value}',
    每日提款限额: 'Daily Withdraw Number',
    每日提现次数: 'Cantidad de retiros diarios',
    每月累计存款升级VIP等级: 'Monthly cumulative deposit an upgrade VIP level',
    等级: 'Level',
    月度奖金: 'Monthly bonus',
    等级升级奖励: 'Level upgrade bonus',
    现金奖励发放时间: 'Cash Bonus: Based on your VIP level at the end ofthis month, thisreward will be sent to you at 10a.m. on the Ist of next month.',
    晋级彩金: 'Upgrade Bonus',
    每月奖金: 'Monthly Bonus',
    投注返水: 'Bet Rebate',
    网络问题: 'Network Problem',
    '检测到您目前没有网络连接，请开启网络后再试。': 'Detected that you currently have no network connection, please try again after turning on the network.',
    设置: 'Settings',
    总奖励: 'Total Rewards',
    邀请总数: 'Total Invites',
    邀请有效用户数量: 'You have invited a total of {value1} friends, of which {value2} are valid users.',
    邀请新客户获得: 'Invite a new customer get',
    邀请好友可获得: 'Invited friends get',
    邀请好友获取金钱: 'Invite friends to get money',
    每日邀请次数: 'Daily invite limit: {value}',
    邀请300位好友可获得: 'Invite {value} friends get',
    如何参与: 'HOW TO PARTICIPATE',
    步骤1: 'Step 1: Register',
    步骤2: 'Step 2: Click on any invitation page to invite friends',
    步骤3: 'Step 3: Share your invite link to your friends, once your friend registered by clicking invite link it will automatically become your subordinate',
    步骤4: 'Step 4: Friends deposits {value}',
    步骤5: 'Step 5: Receive rewards',
    什么是有效邀请用户: 'WHAT IS AN VALID INVITED USER?',
    有效邀请用户描述: 'An valid invited user is someone who has deposited a cumulative amount greater than {value}',
    奖励兑换: 'REWARD REDEMPTION',
    奖励兑换步骤1: 'For each successful invitation, the inviter receives {value1}.',
    奖励兑换步骤2: 'The direct agent (inviter’s superior) receives a {value} bonus.',
    奖励兑换步骤3: 'The superior agent of the direct agent receives a {value} bonus.',
    奖励兑换步骤4: 'The invited user also receives a {value} bonus.',
    奖励兑换步骤5: 'The reward can be used to play games.',
    奖励兑换步骤6: 'Rewards are automatically distributed by the system.',
    活动解释权: '{value} reserves the right of final interpretation for this activity.',
    '安装权限未被授予，无法打开APK文件': 'Installation permission not granted, unable to open APK file',
    '权限已授予，正在尝试打开APK...': 'Permission granted, trying to open APK...',
    立即更新: 'Update now',
    稍后更新: 'Update later',
    版本号不符合规范: 'Version number does not meet the specifications',
    邀请人数: 'Invitation count',
    奖励详情: 'REWARD DETAIL',
    '网络错误, 请稍后重试!': 'Network error, please try again later!',
    存款金额: 'Deposit Amount',
    奖励金额: 'Reward amount',
    立即存款: 'Deposit Now',
    今天不再显示: "Don't show again today",
    倒计时: 'countdown',
    应用未安装: 'Application not installed',
    邀请码: 'Invitation code',
    请输入用户名: 'Please enter your username',
    密码: 'Password',
    请输入密码: 'Please enter your password',
    '密码必须为(6~18位)字母或数字组合': 'Password must be a combination of (6~18 characters) of letters or numbers',
    忘记密码: 'Forget password',
    注册账号: 'Register account',
    重置密码: 'Reset password',
    '确定进入游戏吗?': 'Are you sure you want to enter the game?',
    进入游戏失败: 'Failed to enter the game',
    '确定要支付吗?': 'Are you sure you want to make the payment?',
    充值请求已取消: 'Top-up request has been cancelled',
    已提交充值请求: 'Top-up request has been submitted',
    存款方式: 'Deposit Methods',
    存款账户: 'Deposit Account',
    收款户名: 'Recipient Name: ',
    银行账户: 'Bank Account: ',
    开户地址: 'Bank Branch Address: ',
    开户银行: 'Bank Name: ',
    单笔范围: 'Single Transaction Range: ',
    存款优惠: 'Deposit Event',
    最高奖金: 'Maximum Bonus: ',
    剩余数量: 'Remaining Quantity: ',
    不选择: 'Do not select',
    请选择优惠: 'Please select an offer',
    充值优惠详情: 'Top-up Offer Details',
    详情: 'Details',
    最小额: 'Min',
    最大额: 'Max',
    存款提示: 'Deposit Tips',
    存款提示1: 'Each deposit will be credited within 1-5 minutes',
    存款提示2: 'You can contact customer service anytime to resolve deposit issues',
    充值金额不能小于最小金额: 'The top-up amount cannot be less than the minimum amount',
    立即支付: 'Pay Now',
    下一步: 'Next Step',
    USDT数量: 'USDT Quantity',
    充值金额: 'Top-up Amount',
    复制: 'Copy',
    TXID后五位: 'Last Five Digits of TXID',
    汇款信息: 'Remittance Information',
    '(必填)请输入汇款人姓名或者卡号后四位': "(Required) Please enter the remitter's name or the last four digits of the card number",
    上一步: 'Previous',
    备注信息不允许为空: 'Remark information cannot be empty',
    收款银行: 'Receiving Bank',
    银行地址: 'Bank Address',
    PIX类型: 'PIX Type',
    账号名称: 'Account Name',
    收款账户: 'Receiving Account',
    PIX账号: 'PIX Account',
    选择钱包类型: 'Select Wallet Type',
    '获取钱包列表失败, 请联系客服': 'Failed to retrieve wallet list, please contact customer service',
    请选择钱包类型: 'Please select wallet type',
    收款地址: 'Receiving Address',
    当前汇率: 'Current Exchange Rate',
    转换金额: 'Converted Amount',
    单日提现金额上限: 'Daily Withdrawal Amount Limit: ',
    单日提现次数上限: 'Daily Withdrawal Frequency Limit: ',
    单笔最低提现额度: 'Minimum Single Withdrawal Amount: ',
    单笔最高提现额度: 'Maximum Single Withdrawal Amount: ',
    提现时间段: 'Withdrawal Time Period: ',
    普通余额: 'Regular Balance: ',
    代理余额: 'Agent Balance: ',
    普通余额可兑换USDT数量: 'Convertible USDT from Regular Balance: ',
    代理余额可兑换USDT数量: 'Convertible USDT from Agent Balance: ',
    '你还没绑定三方钱包哦!': "You haven't linked a third-party wallet yet!",
    选择钱包: 'Select Wallet',
    请输入提现金额: 'Please enter withdrawal amount',
    请输入有效金额: 'Please enter a valid amount',
    请输入正整数金额: 'Please enter a positive integer amount',
    普通余额不足: 'Insufficient regular balance',
    代理余额不足: 'Insufficient agent balance',
    请选择三方钱包: 'Please select a third-party wallet',
    '你还没虚拟货币地址哦!': "You don't have a cryptocurrency address yet!",
    请输入要兑换的USDT数量: 'Please enter the amount of USDT to be exchanged',
    请输入有效枚数: 'Please enter a valid quantity',
    请输入正整数枚数: 'Please enter a positive integer quantity',
    提款数量不能大于可提款USDT数量: 'The withdrawal amount cannot exceed the available USDT amount',
    请输入提款金额: 'Please enter the withdrawal amount',
    请选择钱包: 'Please select a wallet',
    '你还没绑定银行卡哦!': "You haven't linked a bank card yet!",
    选择银行卡: 'Select Bank Card',
    请选择银行卡: 'Please select a bank card',
    '你还没绑定PIX哦!': "You haven't linked a PIX yet!",
    选择PIX: 'Select PIX',
    请选择PIX类型: 'Please select the PIX type',
    '你还没绑定支付宝哦!': "You haven't linked an Alipay yet!",
    选择支付宝: 'Select Alipay',
    请选择支付宝: 'Please select Alipay',
    去绑定: 'Go to link',
    已选: 'Selected',
    兑换全部: 'Exchange All',
    当前提款不在时间段内: 'The current withdrawal is not within the time period',
    钱包中心: 'Wallet Center',
    绑卡提示: 'Dear user, for your information security, by default, you can only link {value} cards. If you need to add or modify, please contact customer service',
    钱包地址: 'Wallet Address',
    请输入钱包地址: 'Please enter wallet address',
    请输入字母或数字: 'Please enter letters or numbers',
    钱包姓名: 'Wallet Name',
    请输入钱包姓名: 'Please enter wallet name',
    持卡人姓名: "Cardholder's Name",
    钱包名称: 'Wallet Name',
    钱包账号: 'Wallet Account',
    开户行地址: 'Bank Branch Address',
    钱包类型: 'Wallet Type',
    "TRC20需以字母'T'开头的34位字符": "TRC20 must be 34 characters starting with 'T'",
    银行卡类型: 'Bank Card Type',
    请选择银行卡类型: 'Please select bank card type',
    请输入开户行地址: 'Please enter bank branch address',
    已有银行卡号: 'Existing Bank Card Number',
    请输入已有银行卡号: 'Please enter existing bank card number',
    银行卡账号: 'Bank Account Number',
    请输入银行卡账号: 'Please enter bank card account',
    请输入持卡人姓名: "Please enter cardholder's name",
    银行名称: 'Bank Name',
    银行账号: 'Bank Account',
    支付宝姓名: 'Alipay Name',
    请输入支付宝姓名: 'Please enter Alipay name',
    支付宝账号: 'Alipay Account',
    请输入支付宝账号: 'Please enter Alipay account',
    添加新账户: 'Add New Account',
    资料信息提交成功: 'Information submitted successfully',
    联系地址: 'Contact Address',
    请输入联系地址: 'Please enter contact address',
    完善信息: 'Complete Information',
    请先完善个人信息: 'Please complete personal information first',
    请先选择优惠: 'Please select a discount first',
    请输入PIX账号: 'Please enter PIX account',
    活动金额: 'Activity Amount',
    更换成功: 'Replacement successful',
    注册成功: 'Registration successful',
    注册失败: 'Registration failed',
    请选择线路: 'Please select a line',
    '线路{value}': 'Line {value}',
    存款前请先绑定银行卡: 'Deposit first before binding bank card',
    额度回收: 'Recovery of credit',
    一键刷新: 'one-click refresh',
    一键回收: 'one-click recycle',
    主平台金额: 'main platform amount',
    我的团队俱乐部: 'My Team Club',
    俱乐部星级: 'Club Stars',
    俱乐部星级提示: "You and all your agents form your club. The higher the club's star rating, the higher the rebate ratio.",
    俱乐部成员: 'Club Members',
    俱乐部投注: 'Club Bet',
    我的返佣: 'My Rebate:',
    投注返佣高达: 'Bet Rebate  Up to',
    首次存款返佣: 'First Deposit Rebate',
    可领取: 'Withdrawable',
    领取: 'Claim',
    领取成功: 'Claimed',
    领取失败: 'Failed to claim',
    今日奖励: "Today's Rewards",
    邀请朋友: 'Invite Friends',
    通过WhatsApp邀请: 'Invite via WhatsApp',
    保存图片: 'Save Picture',
    分享: 'Share',
    从属数据: 'Subordinate Data',
    总人数: 'Total number',
    本月: 'This month',
    层级: 'Tier',
    加入时间: 'Join Time',
    佣金: 'Commission',
    提款历史记录: 'Withdrawal History',
    邀请: 'Invite',
    邀请任务: 'Invite Task',
    时间: 'Time',
    佣金金额: 'Commission Amount',
    成功: 'Success',
    下级: 'Subordinate',
    受邀人数: 'Invited Number',
    佣金总额: 'Total Commission',
    提现公告: '{value1} successfully withdraws {value2}',
    个人资料: 'Profile',
    用户信息: 'User Info',
    昵称: 'Username',
    今天1: 'Today',
    昨天1: 'Yesterday',
    奖励详情1: 'Reward Detail',
    投注1: 'Bet',
    存款1: 'Deposit',
    状态1: 'Status',
    邀请奖励高达: 'Invite Rewards Up to',
    平台名称: 'Platform Name',
    金额: 'Amount',
    刷新: 'Refresh',
    回收: 'Recycle',
    休眠提示: 'Clicks too frequent, please try again after {value} seconds',
    刷新成功: 'Refresh successful',
    刷新失败: 'Refresh failed',
    回收成功: 'Recycle successful',
    回收失败: 'Recycle failed',
    存款提示3: '1.Each deposit will be credited within 1-5 minutes.',
    存款提示4: '2.You can contact customer service at any time to resolve deposit issues.',
    提款提示: 'Withdraw tips',
    提款提示1: 'Under normal circumstances, the withdrawal amount will arrive in your account in about 2 hours, and longest time will not exceed 24 hours',
    钱包: 'Wallet',
    我的余额: 'My Balance',
    绑定手机号: 'Bind Phone No.',
    绑定成功: 'Binding successful',
    未绑定: 'Unbound',
    验证码发送失败: 'Verification code sending failed',
    投注记录: 'Bet Record',
    投注金额: 'Bet Amount',
    投注时间: 'Bet Time',
    订单号: 'Order No',
    平台: 'Platform',
    游戏名: 'Game Name',
    玩法: 'Play Method',
    投注模式: 'Bet Mode',
    有效投注: 'Valid Bet',
    盈亏金额: 'Profit and Loss',
    '1、功能优化、性能优化': '1. Functional optimization, performance optimization',
    '2、修复一些已知问题': '2. Fix some known issues',
    发现新版本: 'New version found',
    奖励2: 'Rewards',
    下一次免费旋转: 'Next Free Spin',
    请输入正确的IFSC码: 'Please enter the correct IFSC code',
    记录: 'Record',
    提款剩余时间: 'Withdrawl time remaining',
    收集提现: 'To withdraw when you collect {value}',
    剩余提现额: '<span style="font-size: 13px;color: #ffffff;">only <span style="font-size: 13px;color: #e9b742;">{value}</span> to go</span>',
    邀请好友获得免费旋转: 'Invite friends to get a Free Spin',
    选择您的奖励: 'Choose your reward',
    每日免费提款: 'Free daily withdrawals',
    所有时间: 'All time',
    本周: 'This week',
    上周: 'Last week',
    QQ: 'QQ',
    微信: 'WeChat',
    telegram: 'telegram',
    whatsApp: 'whatsApp',
    line: 'line',
    instagram: 'Instagram',
    手机号格式不正确: 'The phone number format is incorrect',
    请输入真实姓名: 'Please enter your real name',
    不限制: 'No restrictions',
    请输入订单号: 'Please enter the order number',
    立即游戏: 'Play Now',
    '存款 {value} 即可获得 {value} 次旋转。': 'Deposit {value1} to get {value2} spins.',
    '1次': '{value} Span',
    历史: 'History',
    活动规则: 'Activity Rules',
    游戏维护中: 'The game is under maintenance',
    游戏维护时间: 'The game is under maintenance, maintenance time:{value}',
    快捷登录: 'Quick Login',
    绑定Google账号: 'Bind Google Account',
    绑定失败: 'Binding failed',
    支持: 'Support',
    更多: 'More',
    提现次数: '{value} times',
    '请安装Google Play服务': 'Please install Google Play services',
    '暂无相册权限，请前往设置开启权限': 'No album permission, please go to settings to enable permission',
    '暂无相机权限，请前往设置开启权限': 'No camera permission, please go to settings to enable permission',
    '暂无麦克风权限，请前往设置开启权限': 'No microphone permission, please go to settings to enable permission',
    '暂无手机存储权限，请前往设置开启权限': 'No phone storage permission, please go to settings to enable permission',
    请输入IFSC码: 'Please enter IFSC code',
    搜索: 'search',
    恭喜你: 'Congratulations',
    用户名或手机号码: 'username or mobile number',
    请输入用户名或手机号码: 'Please enter your username or mobile number',
    玩法说明: 'Game Rules',
    截止时间: 'Deadline',
    随机投注: 'Random Bet',
    游戏记录: 'Game Record',
    图表趋势: 'Chart Trend',
    我的投注记录: 'My Bet Record',
    期号: 'Issue',
    '大/小': 'Big/Small',
    数字: 'Number',
    颜色: 'Color',
    大: 'Big',
    小: 'Small',
    '投注助手（过去100期）': 'Bet Assistant (past 100 periods)',
    开奖号码: 'Winning Number',
    数量: 'Quantity',
    我同意: 'I agree',
    预售规则详情:
        'In order to protect the legitimate rights and interests of users participating in the pre-sale and maintain normal operation order, the rules are implemented in accordance with relevant agreements and regulations. 1.1 Definition of pre-sale: refers to the sales model in which merchants provide product or service solutions, collect consumer orders through product pre-sale tools, and provide consumers with goods or services in accordance with prior agreements. 1.2 The pre-sale-sale model is a "deposit" model. "Deposit" refers to the fixed amount in the pre-sale price of commodities delivered in advance. "Deposit" can participate in mini games and have a chance to win more deposits. Deposits can be exchanged directly for merchandise. 1.3 Pre-sale products: Refers to the products released by merchants using the pre-sale product tool. Only mark the word pre-sale on the product title or product detail page, and products that do not use the product pre-sale tools are not classified as pre-sale products. 1.4 Pre-sale system: refers to the system product tool provided to support merchants in pre-sale - sale model sales. 1.5 Pre-sale product price: refers to the sales price of pre-sale products. The price of pre-sale products consists of two parts: deposit and final payment.',
    预售规则: 'Pre-sale Rules',
    总金额: 'Total Amount',
    投注金额必须大于0: 'The bet amount must be greater than 0',
    请同意预售规则: 'Please agree to the pre-sale rules',
    投注小于最小限额: 'Bet less than the minimum limit',
    投注大于最大限额: 'Bet more than the maximum limit',
    当前期已封盘: 'The current period is closed',
    请选择投注内容: 'Please select the bet content',
    投注失败: 'Bet failed',
    投注成功: 'Bet successful',
    红色: 'Red',
    绿色: 'Green',
    紫色: 'Purple',
    购买金额: 'Purchase Amount',
    购买数量: 'Purchase Quantity',
    税后金额: 'After-tax Amount',
    税收: 'Tax',
    结果: 'Result',
    选择: 'Select',
    '输/赢': 'Lose/Win',
    创建时间: 'Create Time',
    'WIN GO彩票': 'WIN GO Lottery',
    'WIN GO规则详情':
        'If you spend 100 to trade, after deducting 2 service fees, your contract value is 98:<br/><br/>1. Select green: If the result shows 1,3,7,9, you will get (98*2) 196;If the result shows 5, you will get (98*1.5) 147<br/><br/>2. Select red: If the result shows 2,4,6,8, you will get (98*2) 196;If the result shows 0, you will get (98*1.5) 147<br/><br/>3. Select violet: if the result shows 0 or 5, you will receive (98*4.5) 441<br/><br/>4. Select number: If the result is the same as the selected number, you will receive (98*9) 882<br/><br/>5. Select large: If the result shows 5,6,7,8,9 you will get (98*2) 196<br/><br/>6. Select small: If the result shows 0,1,2,3,4, you will get (98 * 2) 196',
    该玩法不允许下注: 'This play method does not allow betting',
    总赌注: 'Total Bet',
    赔率: 'Odds',
    选择3个唯一号码: 'Select 3 unique numbers',
    '*如果开盘号码与3个投注号码匹配，则中奖。': '*If the opening number matches the 3 betting numbers, you win.',
    '*如果开奖号码是相同号码中的任意三个，则中奖。': '*If the winning number is any three of the same numbers, you win.',
    '*如果开盘号码与2个投注号码匹配，则中奖。（三个相同的数字除外）。': '*If the opening number matches 2 betting numbers, you win. (Except for three identical numbers).',
    选择2个相同的数字: 'Select 2 identical numbers',
    选择一对独特的数字: 'Select a pair of unique numbers',
    '选择至少1对相同号码和1对不同号码进行投注，如果开盘号码与投注号码相符，则中奖。':
        'Select at least 1 pair of identical numbers and 1 pair of different numbers for betting. If the opening number matches the betting number, you win.',
    选择2个不同的数字: 'Select 2 different numbers',
    选择3个不同的数字: 'Select 3 different numbers',
    '*选择3个或更多不同的数字。所抽中的3个号码若不同且符合选择，则中奖': '*Select 3 or more different numbers. If the 3 numbers drawn are different and match the selection, you win',
    '*选择2个或更多不同的号码。 如果抽取的2个号码不同且符合选择，则中奖。': '*Select 2 or more different numbers. If the 2 numbers drawn are different and match the selection, you win.',
    '*若开奖号码为三个连续号码，则中奖。': '*If the winning number is three consecutive numbers, you win.',
    玩法提示1: 'Choose 2 same numbers. If the draw results match your selection, you win (unless 3 numbers are the same).',
    玩法提示2: 'Choose 2 same numbers and 1 different number. If the draw results match your selection, you win.',
    玩法提示3: 'Choose 3 same numbers. If the draw results match your selection, you win.',
    玩法提示4: 'Choose any 3 same numbers. If the draw results are any three of the same numbers, you win.',
    玩法提示5: 'Choose 3 or more different numbers. If the draw results match your selection, you win.',
    玩法提示6: 'Choose any 3 consecutive numbers. If the draw results are any three consecutive numbers, you win.',
    玩法提示7: 'Choose 2 or more different numbers. If the draw results are different numbers and match with your selected numbers, you win.',
    K3彩票: 'K3 Lottery',
    K3规则详情:
        'A quick draw of 3 dice to get 3 numbers in each period, the dice numbers consist of natural numbers from 111 to 666 (no 0), the dice numbers are not always consecutive, you can guess the entire dice or part of the dice.<br/><br/>Sum value<br/>Guess the sum of numerical values of 3 dice<br/><br/>3 equal numbers<br/>Place a bet on 3 special numbers that are the same (111, 222, ..., 666).<br/><br/>2 equal numbers<br/>Place a bet on 2 numbers that are the same<br/><br/>2 same numbers + 1 different number<br/>Place a bet on 2 identical numbers and 1 different number<br/><br/>3 different numbers<br/>Place a bet on 3 different numbers<br/><br/>2 different numbers<br/>Place a bet on 2 different numbers<br/><br/>3 consecutive numbers<br/>Place a bet on 3 consecutive numbers<br/>(123, 234, 345, 456)<br/><br/>Small (3-11)<br/>Large (12-18)',
    总和: 'Sum',
    '奇/偶': 'Odd/Even',
    '2个相同': '2 Same',
    '3个相同': '3 Same',
    '3个连续': '3 Consecutive',
    不同数字: 'Different Numbers',
    '5D彩票': '5D Lottery',
    '5D规则详情':
        'Draw instructions<br/>5-digit number (00000-99999) will be drawn randomly in each period<br/>for example:<br/>The draw number for this Period is 12345<br/>A=1<br/>B=2<br/>C=3<br/>D=4<br/>E=5<br/>SUM=A+B+C+D+E=15<br/>How to play<br/>Players can specify six betting outcomes A, B, C, D, E and the sum<br/>A, B, C, D, E can be purchased<br/>Number (0 1 2 3 4 5 6 7 8 9)<br/>Low (0 1 2 3 4)<br/>Odd (1 3 5 7 9)<br/>High (5 6 7 8 9)<br/>Odd (1 3 5 7 9)<br/>Even (0 2 4 6 8)<br/>Sum = A+B+C+D+E can be purchased<br/>Low (0-22)<br/>High (23-45)<br/>Odd (1 3 ···43 45)<br/>Pair (0 2 ···42 44)',
    下拉即可刷新: 'Pull down to refresh',
    释放即可刷新: 'Release to refresh',
    没有更多了: 'No more',
    试玩提示: 'You are entering a trial experience;withdrawals are not available after making a profit',
    分享链接: 'Share link',
    应用已更新: 'The application has been updated',
    点击确定重启App生效: 'Click OK to restart the App',
    热门: 'Hot',
    最近: 'Recent',
    收藏: 'Favorite',
    邀请好友帮忙提现: '1. Invite friends to help with withdrawals',
    向随机玩家发送邀请以提供帮助: '2. Send invitation to random player to help',
    通过短信发送消息: 'Send Message on ',
    短信: 'SMS',
    今天剩余提款额度: "Today's remaining withdrawal amount",
    VIP每日限额: 'VIP daily limit',
    今天剩余提款次数: "Today's remaining withdrawal times",
    VIP每日提款次数: 'VIP daily withdrawal times',
    单笔最小提款: 'Single minimum withdrawal amount',
    单笔最大提款: 'Single maximum withdrawal amount',
    USDT地址: 'USDT address',
    今天提款次数已用完: "Today's withdrawal times have been used up",
    提现提示: 'Withdrawal Tips',
    系统异常: 'System abnormality',
    '你好，我们有一份礼物送给你': 'Hi, we have a gift for you',
    请输入礼品代码: 'Please enter the gift code',
    奖金金额: 'Bonus amount: {value}',
    关注官方渠道获取代码: 'Follow official channel to get the code',
    '该金额暂无可用的充值通道,请更换充值金额': 'There is no available recharge channel for this amount. Please change the recharge amount.',
    联系客服: 'Contact Customer Service',
    上月: 'Last month',
    礼物: 'Gifts',
    公链查询: 'Public Chain Query',
    区块: 'Block',
    区块时间: 'Block Time',
    哈希: 'Hash',
    trx详情:
        "What is a hash value?<br/><br/>Anyone who knows the basics of Bitcoin will be exposed to a concept, a hash value. Bitcoin's block header has a hash of the previous block in it, which is used to point to the previous block.<br/><br/>Hash is the transliteration of English hash, we can also translate it into hash, so hash value is also called hash value. A hash value is a value calculated with a hash function (or hash function/hash algorithm). To understand hash values, one must understand the nature of hash functions. A hash function can computationally transform an input of arbitrary length into an output of fixed length.<br/><br/>Every hash function has the property that if the input value is the same, the output hash value is the same. If the input values ​​​​​​​​​​​​are different, the output hashes are usually different, but there is a very small chance of a hash collision . If a hash collision is ruled out with a slight change in the input value, a completely unrelated hash value is output. Since the hash function is irreversible and easy to verify, it is almost impossible to reverse the input value through the output hash value. If there is an input value, the corresponding hash value can be verified immediately.<br/><br/>Therefore, the hash value of each block is unique, random, unbreakable, unforgeable, the block hash value is automatically identified, and the record cannot be tampered with.<br/><br/>How many types of USDT are there?<br/><br/>1. Omni-USDT based on the Bitcoin network, the deposit address is the BTC address, and the deposit and withdrawal go through the BTC network;<br/><br/>2. ERC20-USDT based on the Ethereum ERC20 protocol, the deposit address is the ETH address, and the deposit and withdrawal go through the ETH network;<br/><br/>3. TRC20-USDT based on TRON TRC20 protocol and TRX (TRON) network, the deposit address is the TRON address, and the deposit and withdrawal go through the TRON network.<br/><br/>TrxHash is the TRC20-USDT Block hash based on the TRON TRC20 protocol and TRX (TRON) network. The last number is used as the result of the lottery to determine whether you have won the lottery (click Block Height to go to the public chain to query the unique Block hash)<br/><br/>The rules of play are as follows:<br/><br/>1. 1 lottery draw for 1 minute, purchase within 45 seconds, and the result cannot be purchased within 15 seconds before opening.<br/><br/>2. Purchase All Day Unlock. The total number of purchases in one day is 1440.<br/><br/>3. 3 points 1 time, 5 points 1 time, 10 points 1 time, the rules are the same as 1 point 1 time except the draw time is different.<br/><br/>4. The last digit of the Block hash is used as the lottery result:<br/><br/>Eg:<br/><br/>If the hash value is **b569, the lottery result is 9<br/><br/>Hash value **d14c, the lottery result is 4<br/><br/>if you spend 100 to trade, after deducting service fee 2%, contract amount : 98<br/><br/>l Choose green: if the result shows 1,3,7,9, you will get  (98 * 2) =196  ; if the result shows 5, you will get  (98 * 2) = 196<br/><br/>l choose red: if the result shows 2,4,6,8, you will get  (98 * 2) =196; if the result shows 0, you will get (98 * 2) = 196<br/><br/>l choose purple: if the result shows 0 or 5, you will get  (98 * 2) = 196<br/><br/>l Select the number: If the result of opening is the same as the one you selected, you will get  (98 * 9) = 882<br/><br/>l Choose Big: if the result shows 5,6,7,8,9 you will get  (98 * 2) = 196<br/><br/>l Select Small: if the result shows 0,1,2,3,4 you will get  (98 * 2) = 196",
    'WIN TRX彩票': 'WIN TRX Lottery',
    确认进入游戏吗: 'Are you sure you want to enter the game?',
    奖励兑换码: 'MYSTERY BONUS',
    注册时间: 'Registration time',
    '7 天全额存款': '<span>{value}</span>-day full deposit',
    何时可以领取奖金: 'When can you receive the bonus',
    神秘奖金: 'Mystery Bonus',
    活动已过期: 'Activity expired',
    已领取: 'Received',
    首次存款: 'First Deposit',
    活动说明: 'Activity Description',
    等级优惠: 'Level Bonus',
    当前等级: 'Current Level',
    铁: 'Iron',
    青铜: 'Bronze',
    白银: 'Silver',
    黄金: 'Gold',
    铂金: 'Platinum',
    钻石: 'Diamond',
    近7天游戏营业额: 'Recent {value} Days Turnover',
    未达成: 'Not met',
    已申请: 'Applied',
    已收到: 'Received',
    保存: 'Save',
    每周奖金: 'Weekly Bonus',
    领取时间: 'Collection time',
    加载更多: 'Load more',
    游戏大厅: 'Game Lobby',
    更多游戏: 'More Games',
    底部描述:
        '{value} is operated by {value2} company registration number 142922, with registered address at Zuikertuintjeweg Z/N (Zuikertuin Tower) Curacao and is licensed and authorized by the Government of Curacao. {value} operates under the Master License of Gaming Services Provider, N.V. License Number: GLH-OCCHKTW065752688',
    底部描述2:
        ' <p>1. This product is for use by users 18 years of age or older and is intended for entertainment purposes only.</p><p>2. This game contains in-app purchases.</p><p>3. The fact that a player plays or wins at a social gambling game does not mean that he or she will win at real money gambling and related games in the future.</p>',
    版权声明: '{value} {value2}. All rights reserved. 18+',
    支付成功: 'Payment successful',
    最大掉落: '{value} at a time Max drop',
    每天几次: '{value}X per day',
    当前输赢: 'Current loss',
    当前可领金额: 'Current amount available',
    上一期输赢: 'Last issue loss',
    上一期可领金额: 'Previous Redeemable Amount',
    赎回基金表: 'Redemption Fund Table',
    比赛失败: 'Game failed',
    赎回费用: 'Redemption fee',
    救援金: 'Relief fund',
    本周补偿: 'Compensation for this week',
    本周盈利: 'Profit this week',
    可获得补偿: 'Compensation available',
    本周的补偿将分配到: "This week's compensation will be distributed to",
    每周报酬: 'Weekly Compensation',
    补偿: 'Compensation',
    累计投注: 'Accumulating bets',
    通过累积投注提升VIP等级: 'Upgrade VIP level by accumulating bets',
    立即下载: 'Download now',
    下载应用程序: 'Download App',
    您要下载并安装APP吗: 'Do you want to download and install the APP?',
    暂无可用手机号: 'No mobile phone number available',
    '下载地址不存在，请稍后重试': 'Download address does not exist, please try again later',
    '下载已开始，请在通知栏查看下载进度': 'The download has started, please check the download progress in the notification bar',
    '下载失败，请稍后重试': 'The download failed, please try again later',
    支付倒计时: 'Please complete the payment within {value}',
    支付方式: 'Payment method',
    钱包支付: 'Wallet payment',
    取消充值申请: 'Cancel deposit application',
    查看充值记录: 'View deposit record',
    打开App: 'Open {value}',
    每日游戏收入: 'Game Revenue per day',
    签到奖金: 'Sign in bonus',
    手机号首位不能为0: 'The first digit of the phone number cannot be 0',
    真实姓名只能包含英文字母和空格: 'Real name can only contain English letters and spaces',
    请输入正确的银行卡账号: 'Please enter a valid bank account number',
    请输入15位仅包含数字和字母的账号: 'Please enter a 15-character account number with letters or digits',
    请输入CLABE账号: 'Please enter CLABE account',
    请输入正确的CLABE账号: 'Please enter a valid CLABE account',
    利息: 'Profit',
    转入金额必须大于: 'The transfer amount must be greater than {value}',
    最小金额为: 'Minimum {value}, integer only',
    已转入: 'Loaded',
    年利率: 'Annual interest rate {value}%',
    周期: `<span><span style="color: var(--profit-color-hover);">{value}</span> Resolution Cycle (Max. <span style="color: var(--profit-color-hover);"> {value2}</span>)</span>`,
    待处理: `<span> Pending <span style="color: var(--profit-text-warning);"> {value} </span> (Completed {value2}) </span>`,
    收取: 'Receive',
    累计收益: 'Accumulated Revenue <span style="color: var(--profit-text-warning);">{value}</span>',
    交易类型: 'Transaction Type',
    奖金: 'Bonus',
    详细资料: 'Detailed profile',
    规则说明: 'Rules of care',
    解决周期: 'Resolution Cycle',
    转账金额: 'Transfer amount',
    当前时间: 'Current time',
    存款利息结算: 'After this deposit, the first interest will appear at {value}',
    确认转账: 'Confirmation of Transfer',
    当前储蓄本: 'Current savings book',
    转出金额: 'Amount Transferred Out',
    本次循环的倒计时: 'Countdown time for this loop',
    提取利息提示: 'Once withdrawn,you will lose this cycle interest!',
    确认提现: 'Confirm withdrawal',
    转入: 'Move in',
    账户余额: 'Account Balance',
    提款最小金额: 'Minimum {value}',
    提取金额必须大于: 'Withdrawal amount must be greater than {value}',
    提取金额不能超过账户金额: 'Withdrawal amount cannot exceed account balance',
    提取成功: 'Withdrawal successful',
    提取失败: 'Withdrawal failed',
    转入成功: 'Move in successful',
    转入失败: 'Move in failed',
    无限: 'Unlimited',
    时: '{value} Hour',
    分: '{value} Minute',
    秒: '{value} Second',
    利息宝未开启: 'Profit not opened',
    已完成: 'Completed',
    处理中: 'processing',
    已取消: 'Cancelled',
    已提交: 'Submitted',
    审核中: 'Reviewing',
    已审核: 'Reviewed',
    出款中: 'Withdrawing',
    出款失败: 'Withdrawal failed',
    补单成功: 'Fill order successful',
    补单失败: 'Fill order failed',
    请输入UTR: 'Please enter UTR',
    请输入数字和字母: 'Please enter numbers and letters',
    补单: 'Fill order',
    请输入12位数字: 'Please enter 12 digits',
    最多只能选择9个号码: 'You can only select up to 9 numbers',
    请选择支付方式: 'Please select a payment method',
    用户ID: 'User ID/Phone number',
    总余额: 'Total Balance',
    提现余额: 'Withdrawable Balance',
    请输入用户ID: 'Please enter User ID/Phone number',
    TelegramChannel: 'Telegram Channel',
    真实姓名的长度不小于5个字符: 'Real name must be at least 5 characters',
    下载: 'Download',
    强度: 'Strength',
    余额不足: 'Insufficient balance',
    客服: 'Support',
    有效投注总额: "Total Valid Bets",
    盈亏总额: "Total Profit and Loss",
    注册账户: 'Register account',
    注册完成后可获得奖励: 'After completing the registration, you can <span class="intro-highlight">get {value}</span> rewards',
    
    // Third-party login related
    第三方登录: 'Third-party Login',
    登录方式: 'Login in with',
    
    // Callback page loading related
    '正在处理登录...': 'Processing login...',
    '请稍候，即将为您跳转': 'Please wait, redirecting...',
    赠送中心: 'Gift Center',
    截止日期: 'End date',
    返回顶部: 'Back to top',
    游戏: 'Games',
    搜索游戏: 'Search games',
    下注成功: 'Bet successful',
    下注失败: 'Bet failed',
    游戏历史: 'Game History',
    期数: 'Period',
    存款宝箱: 'Deposit Treasure',
    归回累存: 'Return Deposit Accumulation',
    统计截至: 'Statistics as of',
    剩余天数: 'Days remaining',
    当前累计: 'Current total',
    距: 'Until',
    还差: 'Still needed',
    当前可领取: 'Currently claimable',
    档: 'Tier',
    累计门槛: 'Cumulative threshold',
    赠送金额: 'Bonus amount',
    打码: 'Wagering requirement',
    可提前领取: 'Can be claimed early. Once claimed, higher tiers cannot be reached',
    活动进行中: 'Event in progress',
    活动到期领取: 'Event in progress. Rewards can be claimed after the event ends',
    第几天: 'Day {value}',
    已于第几天领取: 'Claimed <strong>{value1}</strong> on day {value}',
    几天: '{value} days',
    回归每日首存: 'Returning user daily first deposit',
    今日时间: "Today's time",
    今日首笔存款: "Today's first deposit",
    可用奖金: 'Available bonus',
    奖金比例: 'Bonus percentage',
    立即领取: 'Claim now',
    去充值: 'Deposit',
    查看活动: 'View event',
    再充值一点更划算: 'Deposit a little more for a better reward',
    当前档: 'Current tier',
    冲刺档: 'Target tier',
    冲: 'Add',
    直接领取当前奖励: 'Claim {value} now',
    活动结束: 'Event ended',
    恭喜领取成功: 'Reward claimed successfully',
    累计奖励已入账户: 'The accumulated reward {value} has been credited',
    请完成打码流水后提现: 'Complete the wagering requirement before withdrawal',
    知道了: 'Got it',
    去下注: 'Bet now',
    充值后最高赠送: 'Maximum bonus after deposit: {value}',
    倍数: 'Multiplier',
    必须通过此页面充值才能获得多倍奖金: 'You must deposit through this page to receive the multiplier bonus',
    已领取宝箱金额: 'Chest reward received',
    已领取翻倍奖励: '{value}x bonus received',
    充值领取最高: 'Deposit to receive up to {multiple}x, {value} reward',
    说明: 'Instructions',
    翻倍充值说明: 'Multiplier Deposit Instructions',
    参与活动: 'Join event',
    领取额外奖励: 'Claim extra reward',
    开始时间: 'Start time',
    流水倍数: 'Wagering multiplier',
    打开: 'Open',
    继续领取: 'Continue claiming',
    翻倍领取: 'Claim multiplied reward',
}
